module.exports = __webpack_public_path__ + "static/media/VVS.6a14b5ad.svg";